import * as React from 'react';
import { Admin, Resource } from 'react-admin';
import polyglotI18nProvider from 'ra-i18n-polyglot';
import chinese from 'ra-language-chinese';
import dataProvider from './dataProvider';
import authProvider from './authProvider';
import MyLayout from './customLayout/layout';
import LoginPage from './loginPage';
import Dashboard from './dashboardPage';

import { LFAddressList, LFAddressEdit, LFAddressCreate, LFAddressShow } from './components/LJXAdmin/LFAddress';
import { LFSessionList, LFSessionEdit, LFSessionCreate, LFSessionShow } from './components/LJXAdmin/LFSession';
import { LFDeviceMessageList, LFDeviceMessageEdit, LFDeviceMessageCreate, LFDeviceMessageShow } from './components/LJXAdmin/LFDeviceMessage';
import { LFDeviceWeightDataList, LFDeviceWeightDataEdit, LFDeviceWeightDataCreate, LFDeviceWeightDataShow } from './components/LJXAdmin/LFDeviceWeightData';
import { LFJiFenLogList, LFJiFenLogEdit, LFJiFenLogCreate, LFJiFenLogShow } from './components/LJXAdmin/LFJiFenLog';
import { LFJiFenProductList, LFJiFenProductEdit, LFJiFenProductCreate, LFJiFenProductShow } from './components/LJXAdmin/LFJiFenProduct';

chinese.ra.action = { ...chinese.ra.action, confirm: '确认' };
const i18nProvider = polyglotI18nProvider(() => chinese, 'zh');

const App = () => {
  return (
    <Admin
      title="两废回收后台管理"
      layout={MyLayout}
      i18nProvider={i18nProvider}
      dataProvider={dataProvider}
      authProvider={authProvider}
      loginPage={LoginPage}
      dashboard={Dashboard}
    >
      <Resource
        name="Admin/LFAddress"
        list={LFAddressList}
        // edit={LFAddressEdit}
        // create={LFAddressCreate}
        // show={LFAddressShow}
        options={{ group: '回收管理', label: '地址管理' }}
      />
      {/* <Resource
        name="Admin/LFSession"
        list={LFSessionList}
        edit={LFSessionEdit}
        create={LFSessionCreate}
        show={LFSessionShow}
        options={{ group: '回收管理', label: '会话管理' }}
      /> */}
      <Resource
        name="Admin/LFDeviceMessage"
        list={LFDeviceMessageList}
        // edit={LFDeviceMessageEdit}
        // create={LFDeviceMessageCreate}
        // show={LFDeviceMessageShow}
        options={{ group: '回收管理', label: '设备消息' }}
      />
      <Resource
        name="Admin/LFDeviceWeightData"
        list={LFDeviceWeightDataList}
        // edit={LFDeviceWeightDataEdit}
        // create={LFDeviceWeightDataCreate}
        // show={LFDeviceWeightDataShow}
        options={{ group: '回收管理', label: '称重数据' }}
      />
      <Resource
        name="Admin/LFJiFenLog"
        list={LFJiFenLogList}
        // edit={LFJiFenLogEdit}
        create={LFJiFenLogCreate}
        // show={LFJiFenLogShow}
        options={{ group: '回收管理', label: '积分日志' }}
      />
      <Resource
        name="Admin/LFJiFenProduct"
        list={LFJiFenProductList}
        edit={LFJiFenProductEdit}
        create={LFJiFenProductCreate}
        show={LFJiFenProductShow}
        options={{ group: '回收管理', label: '积分商品' }}
      />
    </Admin>
  );
};

export default App;